export function AgentVersionMgmtTab() {
  return (
    <div className="space-y-4 p-4">
      <h3 className="text-lg font-semibold">Agent Version Management</h3>
      <p className="text-sm text-muted-foreground">
        Issue attestations and deployment directives. Create rollouts and manage tenant pins.
      </p>
      <div className="rounded-lg border border-border p-4 text-sm text-muted-foreground">
        Rollout controls active in Gate 3. Currently read-only — view issued manifests in the
        Manifest History tab.
      </div>
    </div>
  );
}
